import { useLocale } from "@translations/locale-context";
import Image from "next/legacy/image";
import React from "react";

const EXPERTS: {
    src: string;
    expert: string;
    title: { cs: string; en: string };
    description: { cs: string; en: string };
}[] = [
    {
        src: "/static/caseStudy/mussi.png",
        expert: "Martin Mussil",
        title: {
            cs: "Zkušený expert v\u00a0optimalizaci obchodního výkonu e-shopu, webu nebo aplikace.",
            en: "Experienced expert in optimizing the business performance of an\u00a0e-shop, website or apps. ",
        },
        description: {
            cs: "Na poli e-commerce se\u00a0pohybuje již 13\u00a0let a\u00a0pomáhal růst největším českým online projektům. Jeho know-how pomáhá firmám růst a\u00a0minimalizovat rizika.",
            en: "He has been active in the field of e-commerce for 13 years and has helped with the growth of the largest Czech e-commerce projects. His know-how helps companies grow and minimize risks.",
        },
    },
    {
        src: "/static/caseStudy/grafik.png",
        expert: "Jakub Gräf",
        title: {
            cs: "Náš přední UX odborník s\u00a0kořeny ve\u00a0vývoji.",
            en: "Our leading UX expert with roots in development.",
        },
        description: {
            cs: "Chytře kombinuje zkušenosti vývojáře a\u00a0designera, díky kterým pomáhá našim nejvýznamnějším klientům budovat produkty od\u00a0A\u00a0do\u00a0Z, včetně vize, wireframingu, prototypů a\u00a0testování.",
            en: "He cleverly combines the experience of a\u00a0developer and designer, thanks to which he helps our most important clients build products from A to Z, including visioning, wireframing, prototyping and testing.",
        },
    },
    {
        src: "/static/caseStudy/anicka.png",
        expert: "Anna Argaláš",
        title: {
            cs: "Odbornice na\u00a0výzkum, zkoumá uživatelské cesty, motivace a\u00a0body zájmu.",
            en: "A research expert, she explores user journeys, motivations and points of interest",
        },
        description: {
            cs: "Studovala product design v\u00a0Norsku na\u00a0Oslo Metropolitan University. Znalosti a\u00a0dovednosti v\u00a0oblasti research a\u00a0UX využívá ke\u00a0kvalitativnímu zkoumání a\u00a0vyhodnocování potřeb uživatelů.",
            en: "She studied product design in Norway at Oslo Metropolitan University. She uses her knowledge and skills in research and UX to qualitatively explore and evaluate user needs.",
        },
    },
];

const ContentCs = () => (
    <>
        <h2 className="text-h2Mobile font-bold text-uxfViolet sm:pb-4 sm:text-medium xl:text-h5">
            Našimi audity vás provedou <span className="text-uxfOrange">zkušení odborníci</span> v&nbsp;oboru
        </h2>
    </>
);

const ContentEn = () => (
    <>
        <h2 className="text-h2Mobile font-bold text-uxfViolet sm:pb-4 sm:text-medium xl:text-h5">
            You will be guided by <span className="text-uxfOrange">experienced experts </span>in the field
        </h2>
    </>
);

export const ExpertCards = () => {
    const locale: "cs" | "en" = useLocale();
    return (
        <>
            {EXPERTS.map((expert) => (
                <div key={expert.expert} className="text-small1 sm:text-body">
                    <div className="max-sm:w-[80px]">
                        <Image src={expert.src} alt="avatar" width={120} height={120} />
                    </div>
                    <p className="pb-3 pt-4 font-bold text-uxfViolet">{expert.expert}</p>
                    <div className="text-small1 text-uxfMuted75 sm:text-body">
                        <p className="pb-4">{expert.title[locale]}</p>
                        <p>{expert.description[locale]}</p>
                    </div>
                </div>
            ))}
        </>
    );
};

export const ExpertsSection = () => {
    const locale: "cs" | "en" = useLocale();
    return (
        <div className="container px-5 pb-10 sm:pb-14 md:px-0">
            <div className="pb-6 sm:pb-14">{locale === "en" ? <ContentEn /> : <ContentCs />}</div>
            <div className="grid grid-cols-1 gap-16 md:grid-cols-3 md:gap-10">
                <ExpertCards />
            </div>
        </div>
    );
};
